"use strict";

exports.__esModule = true;
exports.default = css;

function css(_strings) {
  throw new Error('Using the "css" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly.');
}
//# sourceMappingURL=css.js.map